<template>
  <div>
    
    <form @submit.prevent="saveItem(saleItem)">
      <div class="row align-items-end">
        <!-- <div class="col-xl-3 col-12 my-3">
          <label for="">Catégorie</label>
          <vue-select
            :options="sections"
            v-model="section_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div> -->

        <div class="col-xl-3 col-12 my-3">
          <label for="itemInput">Produit</label>
          <vue-select
            :options="filteredItems"
            v-model="saleItem.item_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div v-if="shouldShowStockQuantity" class="col-xl col-12 my-3">
          <label for="">Stock disponible</label>
          <input
            :value="
              availableStockQuantity !== null
                ? availableStockQuantity +
                  (selectedItemMeasuring ? ' ' + selectedItemMeasuring : '') +
                  (isMultipleStock &&
                  saleItem.stock_reference &&
                  selectedStockQuantity !== null
                    ? ' (Sélectionné: ' + selectedStockQuantity + ')'
                    : '')
                : '0'
            "
            disabled
            class="form-control"
          />
        </div>

        <!-- <div class="col-xl-2 col-12 my-3">
          <label>Prix d'achat TTC</label>
          <input
            :value="singlePurchasePriceTTC"
            disabled
            class="form-control"
          />
        </div> -->

        <div v-if="isMultipleStock" class="col-xl-3 col-12 my-3">
          <label for=""> Stock <span class="text-danger">*</span> </label>
          <select
            v-model="saleItem.stock_reference"
            class="form-select"
            :class="{
              'is-invalid':
                isMultipleStock &&
                !saleItem.stock_reference &&
                saleItem.item_reference,
            }"
          >
            <option value="">Sélectionner un stock</option>
            <option
              v-for="(stock, index) in filteredStockItems"
              :key="index"
              :value="stock.reference"
            >
              {{ stock.stockFullName }} - Quantité :
              {{ parseFloat(stock.quantity || 0).toFixed(2) }}
              {{ stock.measuring }}
            </option>
          </select>
          <div
            v-if="
              isMultipleStock &&
              !saleItem.stock_reference &&
              saleItem.item_reference &&
              filteredStockItems &&
              filteredStockItems.length > 0
            "
            class="invalid-feedback"
          >
            Veuillez sélectionner un stock
          </div>
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">
            Quantité
            <span v-if="isQuantityExceedingStock" class="text-danger small ms-2 fw-bold">
              - Stock insuffisant (max: {{ availableStockQuantity }} {{ selectedItemMeasuring || "" }})
            </span>
          </label>
          <input
            v-model="saleItem.quantity"
            type="text"
            :max="
              shouldShowStockQuantity && availableStockQuantity !== null
                ? parseFloat(availableStockQuantity)
                : null
            "
            step="0.01"
            :class="[
              'form-control',
              { 'is-invalid': isQuantityExceedingStock },
            ]"
            @input="validateQuantity"
          />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Quantité (Unites) </label>
          <input v-model="saleItem.pcs" type="text" class="form-control" />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Prix U </label>
          <input v-model="saleItem.priceTTC" class="form-control" />
        </div>

        <div class="col-xl col-6 my-3">
          <label for="">Total </label>
          <input 
            :value="itemTotalPriceTTC" 
            disabled 
            class="form-control bg-light" 
          />
        </div>

        <div class="col-xl col-12 my-3">
          <label for=""> Remarque </label>
          <input v-model="saleItem.remark" class="form-control" />
        </div>
      </div>

      <hr />
      <div class="row justify-content-end">
        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button class="btn btn-success shadow" type="submit">
            <i class="bi bi-plus-circle"></i> Insérer
          </button>
        </div>

        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center"
            @click="refresh()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Actualiser </span>
          </button>
        </div>
      </div>
    </form>
    <br />

    <!-- Items Table -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Prix TTC</th>
          <th scope="col">Quantité</th>
          <th scope="col">Total TTC</th>
          <th scope="col">Remarque</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in saleItems" :key="index++">
          <td>
            {{ index }}
          </td>

          <td>
            <span v-if="item.item && item.item.fullName">
              {{ item.item.fullName }}
            </span>
            <span v-else-if="item.itemFullName">
              {{ item.itemFullName }}
            </span>
          </td>

          <td class="">
            <span v-if="item.priceTTC != null">
              {{ item.priceTTC }}
            </span>
          </td>

          <td class="">
            <span v-if="item.quantity != null">
              {{ item.quantity }}
            </span>
            <span v-if="item.item && item.item.measuring">
              {{ item.item.measuring }}
            </span>
            <span v-else-if="item.itemMeasuring">
              {{ item.itemMeasuring }}
            </span>
          </td>
          <td class="">
            <span v-if="item.totalPriceTTC != null">
              {{ item.totalPriceTTC }}
            </span>
          </td>

          <td>
            {{ item.remark }}
          </td>

          <td class="d-flex">
            <button @click="removeItem(item)" class="btn text-danger">
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-0">
          <td></td>
          <td>Total :</td>
          <td class=""></td>
          <td>
            <span class="fw-bold bg-warning px-2 py-1 rounded">
              {{ parseFloat(totalQuantityItems).toFixed(2) }}
            </span>
          </td>
          <td>
            <span class="fw-bold bg-warning px-2 py-1 rounded">
              {{ parseFloat(totalPriceTTCItems).toFixed(2) }}
            </span>
            DH
          </td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <br />

    <!-- Totals Summary -->
    

    <!-- Sale Form Section -->
    <div class="row align-items-end">
      <div class="col-xl-3 col-12 my-3">
        <label for="">Société <span class="text-danger">*</span> </label>
        <vue-select 
          :options="societies"
          v-model="sale.society_reference"
          placeholder="Sélectionner une société"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">
          Client <span class="text-danger">*</span>
          <span v-if="creditError" class="text-danger small ms-2 fw-bold">- Crédit dépassé</span>
        </label>
        <vue-select 
          :options="customers"
          v-model="sale.customer_reference"
          placeholder="Select an option"
          labelColumn="society"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" :disabled="$userRole!='Admin'?true:false" v-model="sale.date" class="form-control" />
      </div>

      <div class="col-auto my-3">
        <label for=""> </label>
        <button @click="selectTodayDate" class="btn btn-secondary">
          Date d'aujourd'hui
        </button>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Échéance </label>
        <input type="date" v-model="sale.deadline" class="form-control" />
      </div>

      <div class="col-xl-12 col-12 my-3">
        <label for=""> Remarque <span class="text-danger">*</span></label>
        <textarea
          type="date"
          v-model="sale.remark"
          class="form-control"
        ></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12"></div>
      <div class="col-xl-auto col-12">
        <button
          class="btn btn-success"
          @click="save(sale)"
        >
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-12 col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      sale: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        amountPaid: 0.0,
        society_reference: "",
        customer_reference: this.$route.query.customer_reference,
      },
      saleItem: {
        item_reference: "",
        stock_reference: "",
        quantity: "",
        pcs: "",
        priceTTC: "",
      },
      section_reference: null,
      item_reference: null,
      itemCode: null,
      accept: false,
      selectedCustomer: {},
      customer_reference: "",
      showError: false,
      errorFields: [],
      order_reference: "",
      selectedItem: {},
      creditError: "",
    };
  },
  computed: {
    ...mapGetters("sale", {
      saleItems: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      numberItems: "numberItems",
      errors: "getErrors",
    }),
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("section", {
      sections: "getAll",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("society", {
      societies: "getAll",
    }),
    ...mapGetters("employee", {
      employees: "getAll",
    }),
   
    ...mapGetters("stock", {
      stockItems: "getStockItems",
    }),
    ...mapGetters("order", {
      orders: "getAll",
    }),

    filteredStockItems() {
      if (this.saleItem.item_reference)
        return this.stockItems.filter(
          (stockItem) =>
            stockItem.item_reference == this.saleItem.item_reference
        );
      return null;
    },

    filteredItems() {
      if (this.section_reference == null) {
        return this.items;
      }

      return this.items.filter(
        (item) => item.section_reference == this.section_reference
      );
    },
    singlePurchasePriceTTC() {
      if (this.filteredStockItems && this.filteredStockItems.length === 1) {
        return this.filteredStockItems[0].purchasePriceTTC;
      }
      return "";
    },
    isMultipleStock() {
      if (this.$settings && this.$settings.stock) {
        return this.$settings.stock === "multiple";
      }
      if (this.$setting && typeof this.$setting === "function") {
        const stockValue = this.$setting("stock");
        return stockValue === "multiple";
      }
      return false;
    },
    shouldCalculateStock() {
      if (this.$settings && this.$settings.calculate_stock !== undefined) {
        return (
          this.$settings.calculate_stock === true ||
          this.$settings.calculate_stock === "true" ||
          this.$settings.calculate_stock === 1
        );
      }
      if (this.$setting && typeof this.$setting === "function") {
        const calculateStockValue = this.$setting("calculate_stock");
        return (
          calculateStockValue === true ||
          calculateStockValue === "true" ||
          calculateStockValue === 1
        );
      }
      return false;
    },
    shouldShowStockQuantity() {
      if (!this.saleItem.item_reference) {
        return false;
      }

      let stockValue = "";
      if (this.$settings && this.$settings.stock) {
        stockValue = this.$settings.stock;
      } else if (this.$setting && typeof this.$setting === "function") {
        stockValue = this.$setting("stock") || "";
      }

      return stockValue === "multiple" || stockValue === "individual";
    },
    availableStockQuantity() {
      if (!this.shouldShowStockQuantity || !this.saleItem.item_reference) {
        return null;
      }

      if (!this.filteredStockItems || this.filteredStockItems.length === 0) {
        return 0;
      }

      const totalQuantity = this.filteredStockItems.reduce((sum, stockItem) => {
        const quantity = parseFloat(stockItem.quantity) || 0;
        return sum + quantity;
      }, 0);

      return totalQuantity.toFixed(2);
    },
    selectedStockQuantity() {
      if (
        !this.isMultipleStock ||
        !this.saleItem.stock_reference ||
        !this.filteredStockItems
      ) {
        return null;
      }

      const selectedStock = this.filteredStockItems.find(
        (stock) => stock.reference === this.saleItem.stock_reference
      );

      if (selectedStock) {
        return parseFloat(selectedStock.quantity || 0).toFixed(2);
      }

      return null;
    },
    selectedItemMeasuring() {
      if (
        !this.saleItem.item_reference ||
        !this.items ||
        this.items.length === 0
      ) {
        return null;
      }

      const selectedItem = this.items.find(
        (item) => item.reference === this.saleItem.item_reference
      );
      return selectedItem && selectedItem.measuring
        ? selectedItem.measuring
        : null;
    },
    isQuantityExceedingStock() {
      if (
        !this.shouldShowStockQuantity ||
        this.availableStockQuantity === null
      ) {
        return false;
      }

      const enteredQuantity = parseFloat(this.saleItem.quantity) || 0;
      const availableQuantity = parseFloat(this.availableStockQuantity) || 0;

      return enteredQuantity > availableQuantity;
    },
    itemTotalPriceTTC() {
      const quantity = parseFloat(this.saleItem.quantity) || 0;
      const priceTTC = parseFloat(this.saleItem.priceTTC) || 0;
      const total = quantity * priceTTC;
      return total > 0 ? total.toFixed(2) : "";
    },
  },
  methods: {
    validateQuantity() {
      if (this.isQuantityExceedingStock) {
        const availableQty = parseFloat(this.availableStockQuantity) || 0;
        this.saleItem.quantity = availableQty.toFixed(2);

        this.$store.dispatch(
          "notification/store",
          {
            status: "warning",
            message: `La quantité a été ajustée au stock disponible: ${availableQty}`,
          },
          { root: true }
        );
      }
    },  
    async saveItem(data) {
      if (this.isQuantityExceedingStock) {
        this.validateQuantity();
        return;
      }

      await this.$store.dispatch("sale/storeItem", data);
      this.saleItem.item_reference = "";
      this.saleItem.stock_reference = "";
      this.saleItem.quantity = "";
      this.saleItem.pcs = "";
      this.saleItem.priceTTC = "";
      this.saleItem.remark = "";
      this.section_reference = null;
      this.item_reference = null;
      await this.$store.dispatch("stock/fetchStocksItems");
    },
    async removeItem(data) {
      this.$store.dispatch("sale/destroyItem", data.id);
    },
    async checkCreditLimit() {
      // Reset error
      this.creditError = "";

      if (!this.sale.customer_reference) {
        return false;
      }

      const selectedCustomer = this.customers.find(
        (c) => c.reference === this.sale.customer_reference
      );

      if (!selectedCustomer || !selectedCustomer.maxUnpaid) {
        return false;
      }

      try {
        // Get total unpaid for this customer
        await this.$store.dispatch(
          "sale/getCustomerSalesUnpaid",
          this.sale.customer_reference
        );
        const unpaidSales = this.$store.getters["sale/getSales"] || [];
        const totalUnpaid = unpaidSales.reduce(
          (sum, sale) => sum + parseFloat(sale.amountUnpaid || 0),
          0
        );

        const maxUnpaid = parseFloat(selectedCustomer.maxUnpaid || 0);

        // Check if current total unpaid already exceeds maxUnpaid
        if (totalUnpaid >= maxUnpaid) {
          this.creditError = `Ce client a déjà dépassé son barème de crédit. Total impayé: ${totalUnpaid.toFixed(2)} DH, Limite: ${maxUnpaid.toFixed(2)} DH`;
          return true;
        }

        // Calculate: total unpaid + (total of current saleItems * 2)
        const currentSaleTotal = parseFloat(this.totalPriceTTCItems || 0);
        const totalAfterSale = totalUnpaid + currentSaleTotal * 2;

        // Check if adding this sale would exceed maxUnpaid
        if (totalAfterSale >= maxUnpaid) {
          this.creditError = `Cette vente ferait dépasser le barème de crédit. Total impayé actuel: ${totalUnpaid.toFixed(2)} DH, Total après cette vente (x2): ${totalAfterSale.toFixed(2)} DH, Limite: ${maxUnpaid.toFixed(2)} DH`;
          return true;
        }

        return false;
      } catch (error) {
        console.error("Error checking credit limit:", error);
        return false;
      }
    },
    async save(data) {
      // Check credit limit before saving
      const creditExceeded = await this.checkCreditLimit();
      
      if (creditExceeded) {
        const errorMessage = "Crédit dépassé : " + this.creditError;
        
        // Show toast error
        if (this.$toast && this.$toast.error) {
          this.$toast.error(errorMessage);
        }
        
        // Also dispatch notification
        this.$store.dispatch(
          "notification/store",
          {
            status: "error",
            message: "Impossible d'enregistrer : " + this.creditError,
          },
          { root: true }
        );
        return; // Stop the save operation
      }

      await this.$store.dispatch("sale/store", data);
      await setTimeout(((this.sale = {}), (this.accept = false)), 2000);
    },
    async refresh() {
      await this.$store.dispatch("stock/fetchStocksItems");
      this.$store.dispatch("section/getAll");
      this.$store.dispatch("item/getAll");
      this.$store.dispatch("sale/getAllItems");
      this.$store.dispatch("customer/getAll");
      this.$store.dispatch("order/getAll");
    },
    async onCustomerChangeSelected() {
      await (this.selectedCustomer = this.customers.find(
        (p) => p.reference == this.customer_reference
      ));

      await (this.sale.customer_reference = this.selectedCustomer.reference);

      if (this.selectedCustomer != null) {
        await this.getCustomerSalesUnpaid(this.customer_reference);
        await (this.customer_reference = "");
      }
    },
    async getCustomerSalesUnpaid(customer_reference) {
      this.$store.dispatch("sale/getCustomerSalesUnpaid", customer_reference);
    },
    async selectTodayDate() {
      this.sale.date = new Date(new Date().setFullYear(new Date().getFullYear()))
        .toLocaleString("en-CA")
        .split(",")[0];
    },
  },
  async beforeMount() {
    await this.$store.dispatch("stock/fetchStocksItems");
    await this.$store.dispatch("section/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("sale/getAllItems");
    await this.$store.dispatch("customer/getAll");
    await this.$store.dispatch("society/getAll");
    this.$store.dispatch("employee/getAll");
  },
  watch: {
    "sale.customer_reference": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        // Reset error when customer changes
        this.creditError = "";
        if (newValue) {
          this.checkCreditLimit();
        }
      }
    },
    totalPriceTTCItems: function () {
      // Re-check credit limit when items total changes
      if (this.sale.customer_reference) {
        this.checkCreditLimit();
      }
    },
    "saleItem.item_reference"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.saleItem.stock_reference = "";
        this.$store.dispatch("stock/fetchStocksItems");
      }
      // Set priceTTC when item is selected (like order items)
      if (newValue) {
        this.selectedItem =
          this.filteredItems.find((item) => item.reference === newValue) || {};
        this.saleItem.priceTTC = parseFloat(this.selectedItem.priceTTC) || "";
      } else {
        this.selectedItem = {};
      }
    },
    "saleItem.pcs": function (newValue, oldValue) {
      // Only calculate if pcs changed and we have the necessary data
      if (newValue !== oldValue && newValue && this.selectedItem.pcs) {
        // Calculate quantity from pcs: quantity = pcs / item.pcs
        const calculatedQuantity = parseFloat(
          newValue / this.selectedItem.pcs
        ).toFixed(2);
        // Only update if the calculated value is different to avoid infinite loop
        if (this.saleItem.quantity !== calculatedQuantity) {
          this.saleItem.quantity = calculatedQuantity;
        }
      }
    },
    "saleItem.quantity": function (newValue, oldValue) {
      // Only calculate if quantity changed and we have the necessary data
      if (newValue !== oldValue && newValue && this.selectedItem.pcs) {
        // Calculate pcs from quantity: pcs = quantity * item.pcs (always integer)
        const calculatedPcs = Math.round(
          parseFloat(newValue * this.selectedItem.pcs)
        );
        // Only update if the calculated value is different to avoid infinite loop
        if (this.saleItem.pcs !== calculatedPcs.toString()) {
          this.saleItem.pcs = calculatedPcs.toString();
        }
      }
    },
  },
  filters: {
    date: (value) => {
      return moment(value).format("DD-MM-YYYY");
    },
  },
};
</script>